declare let EnvConf: any;

export const environment = {
    api: EnvConf.api || ''
};
